import { createSceneReducer } from 'reducers/reducers-util';
import submittalsDataReducer from 'components/admin/submittals/store/reducers.data';

export default createSceneReducer(submittalsDataReducer);
